import React from 'react';
import { useOneStopService } from 'domain/shared/oneStop';
import {
  DataGridLayout,
  DESC,
  Filters,
  FiltersLayout,
  List,
  ListHeader,
  ListPageLayout,
  QuickFilter,
} from 'framework/list';
import { FullDateField, LinkField, TextField } from 'framework/ui/field';
import OneStopRequestStatusFilter from 'domain/people/employeePortal/history/filter/OneStopRequestStatusFilter';
import OneStopHistoryRowHighlighter from 'domain/people/employeePortal/history/List/OneStopHistoryRowHighlighter';

enum RequestStatusKey {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
}

const OneStopHistoryPage = () => {
  const { loadHistoryData } = useOneStopService();

  const openRequestsFilter = (
    <QuickFilter
      key="open-requests"
      label="All Open Requests"
      state={{ status: { in: [RequestStatusKey.NEW, RequestStatusKey.IN_PROGRESS] } }}
    />
  );

  const filters = (
    <Filters>
      <FiltersLayout quickFilters={[openRequestsFilter]}>
        <OneStopRequestStatusFilter label="Status" source="status" />
      </FiltersLayout>
    </Filters>
  );

  return (
    <List
      getDataMethod={loadHistoryData}
      defaultSortOrder={DESC}
      defaultSortField="submittedAt"
      defaultFilter={{ status: { in: [RequestStatusKey.NEW, RequestStatusKey.IN_PROGRESS] } }}
    >
      <ListPageLayout filter={filters} header={<ListHeader label="One Stop Requests" icon="fa-archive" />}>
        <OneStopHistoryRowHighlighter>
          <DataGridLayout>
            <LinkField linkSource="taskTrackerIssueLink" source="externalId" label="External ID" />
            <TextField source="serviceName" label="Service" isSortable />
            <TextField source="serviceCategoryName" label="Service category" isSortable />
            <TextField source="subject" label="Subject" />
            <TextField source="status" label="Status" isSortable />
            <FullDateField source="submittedAt" label="Submitted at" isSortable />
          </DataGridLayout>
        </OneStopHistoryRowHighlighter>
      </ListPageLayout>
    </List>
  );
};

export default OneStopHistoryPage;
